import FormControl, { FormControlProps } from '@ui-components-3/ui/lib/components/FormControl'
import Input, { InputProps } from '@ui-components-3/ui/lib/components/Input'
import { forwardRef, ReactNode } from 'react'
import { useController, useFormContext } from 'react-hook-form'

type FormInputProps = Omit<InputProps, 'className' | 'value' | 'onChange'> & {
  name: string
  label?: ReactNode
  className?: string
  formControlProps?: Omit<FormControlProps, 'label' | 'className'>
  inputClassName?: string
}

const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ label, name, className, inputClassName, formControlProps, ...props }, ref) => {
    const {
      formState: { isSubmitted },
    } = useFormContext()

    const {
      field,
      fieldState: { error, isTouched },
    } = useController({ name })

    const { helper, helperVariant, ...restFormControlProps } = formControlProps || {}

    const showError = !!error?.message && (!!isTouched || !!isSubmitted)

    return (
      <FormControl
        {...restFormControlProps}
        label={label}
        className={className}
        helper={showError ? error?.message : helper}
        helperVariant={showError ? 'error' : helperVariant}
      >
        <Input
          {...props}
          {...field}
          variant={showError ? 'error' : props.variant}
          className={inputClassName}
          ref={ref}
        />
      </FormControl>
    )
  },
)

export default FormInput
